import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

import './ThemeRoadMap.css';




const ThemeRoadMap = ({ theme, selectedPoint, setSelectedPoint }) => {
    const [lastActive, setLastActive] = useState(undefined)

    // console.log(theme)

    useEffect(() => {
        const lastActivePoint = theme.lessons.filter(i => i.status !== 'not_started').slice(-1)
        // console.log(theme.lessons.filter(i => i.status !== 'not_started'))
        setLastActive(lastActivePoint)
    }, [theme]);

    const getActiveLineLength = (length, elementNumber) => {
        // console.log(length)
        // console.log(elementNumber)
        if (length > 1 && length != elementNumber + 1 && elementNumber !== 0) {
            let spacesNumber = elementNumber * 2 + 1
            // console.log(spacesNumber)
            return `calc(100% / ${length * 2} * ${spacesNumber})`
        } else if (length > 1 && elementNumber === 0) {
            // console.log('length > 1 && elementNumber === 0')
            // console.log(`calc(100% / ${length * 2})`)
            return `calc(100% / ${length * 2})`
        } else if (length == elementNumber + 1) {
            // console.log('length == elementNumber + 1')
            return `100%`
        } else {
            return `0%`
        }

    }
    return (

        theme && <div className='themeRoadMap__container'>
            <div className='themeRoadMap__title'>{theme.title}</div>
            <div className='themeRoadMap__pipeline'>
                <div className={`themeRoadMap__percent ${theme.percent_completed < 1 ? 'themeRoadMap__percent_empty' : 'themeRoadMap__percent_full'}`}>{theme.percent_completed}%
                    {theme.percent_completed > 0 && <svg className="circle-chart" viewBox="0 0 33.83098862 33.83098862" width="70" height="70" xmlns="http://www.w3.org/2000/svg">
                        <circle className="circle-chart__circle" stroke="#7A5AF8" strokeWidth="2" strokeDasharray={`${theme.percent_completed},100`} strokeLinecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
                    </svg>}
                </div>

                <div className={`themeRoadMap__line ${theme.percent_completed === 100 ? 'themeRoadMap__line_completed' : ''}`}>
                    <div className='themeRoadMap__defaultLine'></div>
                    {lastActive && <div className='themeRoadMap__itemLine' style={{ width: lastActive[0] ? getActiveLineLength(theme.lessons.length, theme.lessons.indexOf(lastActive[0])) : 0, opacity: lastActive[0] ? 1 : 0 }}></div>
                    }
                    {theme.lessons.map((lesson, index) => (

                        <div className={`${lesson.id === selectedPoint ? lesson.status !== 'not_started' ? 'themeRoadMap__point_active' : 'themeRoadMap__point_activeGrey' : lesson.status !== 'not_started' ? 'themeRoadMap__point themeRoadMap__point_disclosed' : ' themeRoadMap__point themeRoadMap__point_undisclosed'}`} key={lesson.id} onClick={() => setSelectedPoint(lesson.id)}>
                            {index + 1}
                            {lesson.status === 'finished' && lesson.id !== selectedPoint && <div className='themeRoadMap__point_completed' />}


                            {lesson.id === selectedPoint &&
                                <Link to={`/resource/${lesson.active_step_id}`}>
                                    <div className='lessonInfo'>
                                        <div className='lessonInfo__header'>
                                            <div className='lessonInfo__progress' style={{ backgroundColor: lesson.status !== 'not_started' ? '#22C532' : '#DFDFDF' }}>{lesson.completed_steps}/{lesson.total_steps}</div>
                                            <div className='lessonInfo__progress' style={{ backgroundColor: lesson.status !== 'not_started' ? '#22C532' : '#DFDFDF' }}>{`${lesson.status !== 'not_started' ? lesson.status === 'finished' ? 'Выполнено' : 'В процессе' : 'Не просмотрено'}`}</div>

                                        </div>
                                        <div className='lessonInfo__name'>{lesson.title}</div>

                                    </div>
                                </Link>
                            }
                        </div>

                    ))}



                </div>
                <Link to={`/theme/${theme.id}`}><div className={`themeRoadMap__button ${theme.percentageCompleted === 100 ? 'themeRoadMap__line_completed' : ''}`}></div></Link>

            </div>

        </div>


    )
}
export default ThemeRoadMap
